import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
//Material
import {
  Button,
  TextField,
  FormControl,
  Box,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
//Components
import { useSyles } from '../styles.style';
import Layout from '../../common/Layout';
import Loading from '../../common/Loading';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAllTypekeys } from '../../../redux/typekeys/thunks';
import { getAllDrawersDivisions } from '../../../redux/drawersdivisions/thunks';
import { getAllProperties } from '../../../redux/properties/thunks';
import { HouseKeyComments } from '../../HousekeyComments';
import CommentIcon from '@material-ui/icons/Comment';
type PropsForm = {
  submitHousekey: (_: any) => void;
  initialValues: any;
  actionText?: any;
  isEdit?: boolean;
};
const Form = ({
  submitHousekey,
  initialValues,
  actionText,
  isEdit = false,
}: PropsForm) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const classes = useSyles();
  const [showForm, setShowForm] = useState(isEdit ? true : false);
  const [propertyNid, setPropertyNid] = useState('');
  const [openComments, setOpenComments] = useState<boolean>(false);

  useEffect(() => {
    if (showForm) {
      dispatch(getAllTypekeys(''));
      dispatch(getAllDrawersDivisions(''));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  // Acceder al state del store
  const { type_keys } = useSelector((state: any) => state.type_keys);
  const { drawers_divisions } = useSelector(
    (state: any) => state.drawers_divisions
  );
  const { properties, loading } = useSelector(
    (state: any) => state.properties.properties
  );

  useEffect(() => {
    if (initialValues && isEdit) {
      const filter = `&nid=${initialValues?.properties_nid}`;
      dispatch(getAllProperties({ filter, pagination: {} }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  // función que redirige de forma programada
  const cancelAdd = () => {
    navigate(`/housekeys`, { replace: true });
  };

  const validationSchema = yup.object({
    drawers_id: yup.string().required('Campo obligatorio'),
    type_keys_id: yup.string().required('Campo obligatorio'),
    serial_number: yup.string().when('type_keys_id', {
      is: (val: string) => String(val) === '9',
      then: (schema) => schema.required('Campo obligatorio'),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  // filtrar por propiedad
  const openCommentHandler = (): void => {
    setOpenComments(true);
  };
  const closeCommentHandler = (): void => {
    setOpenComments(false);
  };
  const handleFilterProperty = () => {
    const filter = `&nid=${propertyNid}`;
    dispatch(getAllProperties({ filter, pagination: {} }));
    setShowForm(true);
  };
  // filtrar por propiedad

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values: any) =>
      submitHousekey({ ...values, properties_nid: propertyNid }),
  });

  const onAction = () => formik?.handleSubmit();

  return (
    <Layout>
      <div className={classes.container}>
        {isEdit ? (
          <form className={classes.form} onSubmit={formik.handleSubmit}>
            <FormControl variant='outlined'>
              <InputLabel>Propiedad</InputLabel>
              <Select
                id='form-properties_nid'
                name='properties_nid'
                value={initialValues.properties_nid}
                readOnly
                disabled
                label='Propiedad'
              >
                <MenuItem value=''>
                  <em>Selecciona una propiedad</em>
                </MenuItem>
                {properties?.map((property: any) => (
                  <MenuItem
                    key={`menu-property-${property.nid}`}
                    value={property.nid}
                  >
                    NID: {property.nid} - ({property.address})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant='outlined'>
              <InputLabel>Tipo de llave</InputLabel>
              <Select
                id='form-type_keys_id'
                name='type_keys_id'
                value={formik.values.type_keys_id}
                onChange={formik.handleChange('type_keys_id')}
                error={
                  formik.touched.type_keys_id &&
                  Boolean(formik.errors.type_keys_id)
                }
                label='Tipo de llave'
              >
                <MenuItem value=''>
                  <em>Selecciona un tipo de llave</em>
                </MenuItem>
                {type_keys?.map((type_key: any) => (
                  <MenuItem key={type_key.id} value={type_key.id}>
                    {type_key.name} ({type_key.description})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {String(formik.values.type_keys_id) === '9' && (
              <FormControl variant='outlined'>
                <TextField
                  variant='outlined'
                  id='form-serial_number'
                  name='serial_number'
                  value={formik.values.serial_number}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\s+/g, ''); // Quita todos los espacios
                    formik.setFieldValue('serial_number', value);
                  }}
                  error={
                    formik.touched.serial_number &&
                    Boolean(formik.errors.serial_number)
                  }
                  label='Número serial'
                />
              </FormControl>
            )}
            <FormControl variant='outlined'>
              <InputLabel>Gaveta</InputLabel>
              <Select
                id='form-drawers_id'
                name='drawers_id'
                value={formik.values.drawers_id}
                onChange={formik.handleChange('drawers_id')}
                error={
                  formik.touched.drawers_id && Boolean(formik.errors.drawers_id)
                }
                label='Gaveta disponible'
              >
                <MenuItem value=''>
                  <em>Selecciona una gaveta</em>
                </MenuItem>
                {properties &&
                  properties[0]?.drawers?.map((drawer: any) => {
                    return (
                      <MenuItem value={drawer.id}>{`${drawer.label} ${
                        drawer.has_key ? ' - Tiene llaves de la propiedad' : ''
                      }`}</MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <div className={classes.flex}>
              <Button
                data-testid='open-comments-button'
                className={classes.button}
                size='medium'
                color='default'
                variant='contained'
                onClick={() => openCommentHandler()}
              >
                <CommentIcon color='action' />
                Comentarios
              </Button>
              <Button onClick={cancelAdd}>Cancelar</Button>
              <Button
                className={classes.button}
                size='medium'
                color='secondary'
                variant='contained'
                onClick={() => onAction()}
              >
                {actionText}
              </Button>
            </div>
          </form>
        ) : (
          <>
            <Box sx={{ display: 'flex', width: '100%', p: 2, mt: 2 }}>
              <TextField
                id='form-properties_nid'
                name='properties_nid'
                label='Ingresa el NID de la propiedad '
                variant='outlined'
                fullWidth
                size='medium'
                value={propertyNid}
                onChange={(e) => setPropertyNid(e.target.value)}
              />
              <Button
                color='primary'
                variant='contained'
                size='small'
                onClick={handleFilterProperty}
                className={classes.input}
              >
                <Search />
              </Button>
            </Box>
            <>
              {showForm && (
                <>
                  {!loading ? (
                    <>
                      {properties[0] ? (
                        <form
                          className={classes.form}
                          onSubmit={formik.handleSubmit}
                        >
                          <Typography component='div' variant='h6'>
                            NID: {properties[0].nid} - ({properties[0].address})
                          </Typography>
                          <FormControl
                            variant='outlined'
                            error={
                              formik.touched.type_keys_id &&
                              Boolean(formik.errors.type_keys_id)
                            }
                          >
                            <InputLabel>Tipo de llave</InputLabel>
                            <Select
                              id='form-type_keys_id'
                              name='type_keys_id'
                              value={formik.values.type_keys_id}
                              onChange={formik.handleChange('type_keys_id')}
                              error={
                                formik.touched.type_keys_id &&
                                Boolean(formik.errors.type_keys_id)
                              }
                              label='Tipo de llave'
                            >
                              <MenuItem value=''>
                                <em>Selecciona un tipo de llave</em>
                              </MenuItem>
                              {type_keys?.map((type_key: any) => (
                                <MenuItem
                                  key={`key_type-${type_key.id}`}
                                  value={type_key.id}
                                >
                                  {type_key.name} ({type_key.description})
                                </MenuItem>
                              ))}
                            </Select>
                            {formik.touched.type_keys_id &&
                              Boolean(formik.errors.type_keys_id) && (
                                <FormHelperText id='form-type_keys_id-text'>
                                  Seleccione un tipo de llave
                                </FormHelperText>
                              )}
                          </FormControl>
                          <FormControl variant='outlined'>
                            <InputLabel>Gaveta</InputLabel>
                            <Select
                              id='form-drawers_id'
                              name='drawers_id'
                              value={formik.values.drawers_id}
                              onChange={formik.handleChange('drawers_id')}
                              error={
                                formik.touched.drawers_id &&
                                Boolean(formik.errors.drawers_id)
                              }
                              label='Gaveta disponible'
                            >
                              <MenuItem value=''>
                                <em>Selecciona una gaveta</em>
                              </MenuItem>
                              {properties &&
                                properties[0]?.drawers?.map((drawer: any) => {
                                  return (
                                    <MenuItem
                                      value={drawer.id}
                                      key={`gav-menu-${drawer.id}`}
                                    >
                                      {`${drawer.label} ${
                                        drawer.has_key
                                          ? ' - Tiene llaves de la propiedad'
                                          : ''
                                      }`}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                          <div className={classes.flex}>
                            <Button onClick={cancelAdd}>Cancelar</Button>
                            <Button
                              type='submit'
                              className={classes.button}
                              size='medium'
                              color='secondary'
                              variant='contained'
                            >
                              {actionText}
                            </Button>
                          </div>
                        </form>
                      ) : (
                        <Typography component='div' variant='h6'>
                          No existe el NID
                        </Typography>
                      )}
                    </>
                  ) : (
                    <Loading />
                  )}
                </>
              )}
            </>
          </>
        )}
      </div>
      {openComments && (
        <HouseKeyComments
          housekey_id={initialValues?.id}
          housekey_code={initialValues?.barcode}
          open
          onClose={closeCommentHandler}
        />
      )}
    </Layout>
  );
};

export default Form;
